import { TileGridBlockData } from 'api/cms';
import { BlockMapping } from 'cms/blocks/BlockMapping';

import { AmpTileGridBlock } from './AmpTileGridBlock';
import { TileGridBlock } from './TileGridBlock';

export const TileGridBlockMapping: BlockMapping<TileGridBlockData> = {
  invariant: [],
  width: 'GRID',
  Component: TileGridBlock,
  AmpComponent: AmpTileGridBlock,
};
